import {
  ProjectDataType,
  RequestStaffInfo,
  StaffDataType,
  StaffHasInMasterData
} from './types';

import axiosInstance from 'services/common/instance';

export const getProjectService = async (code: string)
  : Promise<ProjectDataType> => {
  const res = await axiosInstance.get(`projects/${code}`);
  return res.data.data;
};

export const getStaffService = async (idCardNumber: string, code: string)
  : Promise<StaffDataType> => {
  const res = await axiosInstance.get(`staffs/${idCardNumber}`, {
    params: {
      code
    }
  });
  return res.data.data;
};

export const createStaffService = async (params: RequestStaffInfo)
  : Promise<{ id: number }> => {
  const res = await axiosInstance.post('staffs/register-project', params);
  return res.data.data;
};

export const registerStaffHasInMasterDataService = async (
  idCardNumber: string,
  params: StaffHasInMasterData
): Promise<{ id: number }> => {
  const res = await axiosInstance.post(`staffs/register-project/${idCardNumber}`, params);
  return res.data.data;
};
